'use client';

import { useEffect } from 'react';
import dynamic from 'next/dynamic';
import ParticleCanvas from './components/ParticleCanvas';
import HeroSection from './components/HeroSection';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

// Lazy load below-the-fold components
const LiveSupporterFeed = dynamic(() => import('./components/LiveSupporterFeed'), {
  loading: () => <div className="py-20 px-6 text-center text-vanta-muted">Loading...</div>,
});

const ServerSelection = dynamic(() => import('./components/ServerSelection'), {
  loading: () => <div className="py-20 px-6 text-center text-vanta-muted">Loading...</div>,
});

const WhyVanta = dynamic(() => import('./components/WhyVanta'), {
  loading: () => <div className="py-20 px-6 text-center text-vanta-muted">Loading...</div>,
});

const WhyPlayersSwitched = dynamic(() => import('./components/WhyPlayersSwitched'), {
  loading: () => <div className="py-20 px-6 text-center text-vanta-muted">Loading...</div>,
});

const SupporterPerks = dynamic(() => import('./components/SupporterPerks'), {
  loading: () => <div className="py-20 px-6 text-center text-vanta-muted">Loading...</div>,
});

const LinkAccounts = dynamic(() => import('./components/LinkAccounts'), {
  loading: () => <div className="py-20 px-6 text-center text-vanta-muted">Loading...</div>,
});

export default function HomePage() {
  useEffect(() => {
    // Handle smooth scroll to section if hash is present in URL
    const hash = window.location?.hash;
    if (hash) {
      // Small delay to ensure page is fully loaded
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          element?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    }
  }, []);

  return (
    <>
      {/* Fixed canvas particle background */}
      <ParticleCanvas />

      {/* Vignette overlay */}
      <div className="vignette" aria-hidden="true" />

      {/* Navigation */}
      <Header />

      {/* Main content — positioned above canvas */}
      <main className="relative" style={{ zIndex: 2 }}>
        <HeroSection />

        {/* Divider */}
        <div className="divider max-w-7xl mx-auto px-6" aria-hidden="true" />

        <LiveSupporterFeed />

        {/* Divider */}
        <div className="divider max-w-7xl mx-auto px-6" aria-hidden="true" />

        <ServerSelection />

        <div className="divider max-w-7xl mx-auto px-6" aria-hidden="true" />

        <WhyVanta />

        <div className="divider max-w-7xl mx-auto px-6" aria-hidden="true" />

        <WhyPlayersSwitched />

        <div className="divider max-w-7xl mx-auto px-6" aria-hidden="true" />

        <SupporterPerks />

        <div className="divider max-w-7xl mx-auto px-6" aria-hidden="true" />

        <LinkAccounts />
      </main>

      <Footer />
    </>
  );
}